/**
 * @generated SignedSource<<dc896169d5b0d8bb618d1e138289c68b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedMakeOfferButton_viewer$data = {
  readonly multiItemCartFF: boolean | null;
  readonly " $fragmentType": "PdpSharedMakeOfferButton_viewer";
};
export type PdpSharedMakeOfferButton_viewer$key = {
  readonly " $data"?: PdpSharedMakeOfferButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMakeOfferButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedMakeOfferButton_viewer",
  "selections": [
    {
      "alias": "multiItemCartFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCart"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCart\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3c7c000e946a5c6d3778f92ac7f522c0";

export default node;
